import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface Badge {
  id: number;
  level: number;
  badge_name: string;
  badge_description: string;
  badge_icon: string;
  created_at: string;
}

// 10 niveles, uno cada 100 Cerebrix
const PREDEFINED_BADGES: Badge[] = [
  {
    id: 1,
    level: 1,
    badge_name: 'Aprendiz Financiero',
    badge_description: 'Da tus primeros pasos en el mundo de las finanzas',
    badge_icon: '🔰',
    created_at: '',
  },
  {
    id: 2,
    level: 2,
    badge_name: 'Ahorrador Novato',
    badge_description: 'Aprende los conceptos básicos del ahorro',
    badge_icon: '🐣',
    created_at: '',
  },
  {
    id: 3,
    level: 3,
    badge_name: 'Ahorrador Experto',
    badge_description: 'Domina las técnicas de ahorro',
    badge_icon: '🐥',
    created_at: '',
  },
  {
    id: 4,
    level: 4,
    badge_name: 'Inversor Junior',
    badge_description: 'Inicia tu camino en el mundo de las inversiones',
    badge_icon: '🥉',
    created_at: '',
  },
  {
    id: 5,
    level: 5,
    badge_name: 'Inversor Senior',
    badge_description: 'Expande tus conocimientos en inversiones',
    badge_icon: '🥈',
    created_at: '',
  },
  {
    id: 6,
    level: 6,
    badge_name: 'Estratega Financiero',
    badge_description: 'Desarrolla estrategias financieras efectivas',
    badge_icon: '🎯',
    created_at: '',
  },
  {
    id: 7,
    level: 7,
    badge_name: 'Asesor Junior',
    badge_description: 'Aprende a analizar decisiones financieras',
    badge_icon: '📊',
    created_at: '',
  },
  {
    id: 8,
    level: 8,
    badge_name: 'Asesor Senior',
    badge_description: 'Domina el arte del asesoramiento financiero',
    badge_icon: '🥇',
    created_at: '',
  },
  {
    id: 9,
    level: 9,
    badge_name: 'Experto Financiero',
    badge_description: 'Conviértete en un experto en finanzas personales',
    badge_icon: '👑',
    created_at: '',
  },
  {
    id: 10,
    level: 10,
    badge_name: 'Gurú de las Finanzas',
    badge_description: 'Alcanza el máximo nivel de sabiduría financiera',
    badge_icon: '💎',
    created_at: '',
  }
];

export function useBadges(): UseQueryResult<Badge[]> {
  return useQuery({
    queryKey: ['badges'],
    queryFn: async () => {
      const { data, error } = await supabase
        .from('level_badges')
        .select('*')
        .order('level', { ascending: true });

      if (error) {
        throw error;
      }

      return data as Badge[];
    },
  });
}
